<template>
  <div class="home">
    <div class="discounts">
      <div
        class="ticket"
        v-for="(item, index) in shopCouponList"
        :key="item.id"
      >
        <div
          class="coupon coupon-wave-left coupon-wave-right coupon-yellow-gradient"
        >
          <div class="coupon-info coupon-info-right-dashed">
            <div class="coupon-store">{{ shopName }}</div>
            <div class="coupon-price">{{ item.name }}</div>
          </div>
          <div class="coupon-get">
            <div class="coupon-desc">{{ item.fix }}张</div>
          </div>
        </div>
        <div class="enter">
          <input type="button" value="-" @click="subtraction(index)" />
          <span @mousewheel="mousewheel(index, $event)">{{ item.fix }}</span>
          <input type="button" value="+" @click="addition(index)" />
        </div>
      </div>
    </div>

    <div class="statistics">
      <p v-if="employ != 13">
        {{ ticketTotal }}：<span class="sale">{{ limit }}{{ ticketName }}</span>
      </p>
      <p v-if="employ == 13">
        {{ ticketTotal }}：<span class="sale">{{ money }}元</span>
      </p>
      <p>
        码有效期止：
        <el-date-picker
          v-model="value2"
          type="datetime"
          placeholder="选择日期时间"
          align="right"
          :picker-options="pickerOptions"
          :clearable="false"
        >
        </el-date-picker>
      </p>
      <p>
        固定码张数：<el-input
          type="number"
          v-model="amount"
          min="0"
          max="10000"
          clearable
        ></el-input>
      </p>
      <p>
        固定码名称：<el-input
          type="text"
          v-model="fixedName"
          clearable
        ></el-input>
      </p>
      <p><el-button type="primary" @click="affirm">生成固定码</el-button></p>
    </div>
    <div class="qrs" v-show="show">
      <div class="poster-container" ref="imageTofile">
        <div class="poster-bg-img">
          <div class="poster-bg-mask"></div>
          <p class="time">{{ time }}</p>
          <p class="quantity">总张数{{ amount }}张</p>
          <p class="fixedName">{{ fixedName }}</p>
        </div>
        <div class="poster-content">
          <div id="qrcode" ref="qrcode"></div>
        </div>
      </div>
      <!-- 最终生成的海报图片 -->
      <div id="page">
        <span class="del" @click="del">X</span>
        <div class="exhibition">
          <img id="posterImg" :src="imgsrc" />
          <a
            class="btn btn-sm btn-info pull-right"
            id="export"
            :href="imgsrc"
            download="固定优惠码.png"
          >
            <i class="ace-icon fa fa-download bigger-120"></i>下载二维码
          </a>
          <b class="iconfont icon-printguanbi shut"></b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { util } from "../utils/global";
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
export default {
  data() {
    return {
      shopCouponList: [], // 优惠券列表
      // 停车场id
      parkId: "",
      // 使用的优惠卷ID
      shopCouponId: "",
      // 接收券的单位
      unit: 0,
      // 判断券的单位是否一致
      units: 0,
      // 账户余额
      balance: 0,
      // 页面中展示叠加或卷面值
      limit: 0,
      // 卷扣费金额
      money: 0,
      // 优惠额度描述
      ticketTotal:"优惠合计",
      // 优惠卷的使用数量
      amount: 0,
      // 判断当前商户卷是否能够进行叠加
      addconuts: 0,
      // 判断是否已经使用
      employ: 0,
      // 判断当前券的类型
      type: 0,
      // 可叠加时判断类型
      verdict: {},
      // 扣费金额
      free: "扣费（元）",
      // 券统计单位
      ticketName: "",
      // 商家名称
      shopName: "",
      // 固定码参数
      placeholder: "",
      show: false,
      time: "",
      imgsrc: "",
      fixedName:"",
      pickerOptions: {
        disabledDate(v) {
          return v.getTime() < new Date() - 3600 * 1000 * 24;
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "30天后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            },
          },
          {
            text: "半年后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 183);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      value2: "",
    };
  },

  mounted() {
    let data = JSON.parse(sessionStorage.getItem("shopData"));
    let shopCouponList = []
    for (var i = 0; i < data.shopCouponList.length; i++) {
      data.shopCouponList[i]["num"] = 0;
      data.shopCouponList[i]["fix"] = 0;
      if(data.shopCouponList[i].maxLimitUnit == null || data.shopCouponList[i].maxLimitUnit == 0) {
        shopCouponList.push(data.shopCouponList[i])
      }
    }
    this.addconuts = data.shop.addCount;
    this.shopCouponList = shopCouponList;
    this.shopName = data.shop.name;
  },
  methods: {
    del() {
      // 点击关闭二维码时
      this.$router.go(0);
    },
    down() {
      // 点击下载图片时
      location.href = this.imgsrc + ".png";
    },
    qrCode(url) {
      // 点击生成图片
      let qrcode = new QRCode("qrcode", {
        width: 255, //图像宽度
        height: 255, //图像高度
        colorDark: "#000000", //前景色
        colorLight: "#ffffff", //背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H, //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
      });
      this.time = util.getDays();
      this.show = true;
      qrcode.clear(); //清除二维码
      qrcode.makeCode(url); //生成另一个新的二维码
      setTimeout(() => {
        this.toImage();
      }, 500);
    },
    toImage() {
      // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
      html2canvas(this.$refs.imageTofile, {
        backgroundColor: null,
      }).then((canvas) => {
        let url = canvas.toDataURL("image/png");
        this.imgsrc = url; // 把生成的base64位图片上传到服务器,生成在线图片地址
      });
    },
    affirm() {
      const _this = this;
      let list = JSON.parse(sessionStorage.getItem("shopData"));
      let judge = util.count(_this.shopCouponList, "can");
      // 调用函数将new Date返回的时间格式处理成页面展示需要的时间格式
      var time = util.timeFormat(new Date());
      if (judge == 0) {
        util.hint(400, "请选择一张优惠券");
        return;
      }
      if (_this.amount <= 0) {
        util.hint(400, "固定码张数不能小于或等于0张");
        return;
      } else if (_this.amount > 10000) {
        util.hint(400, "固定码张数不能大于10000张");
        return;
      }
      if(util.isEmpty(_this.value2)) {
        util.hint(400, "请设置有效期时间");
        return;
      }
      if (
        util.timeCharge(time) >= util.timeCharge(util.timeFormat(_this.value2))
      ) {
        util.hint(400, "有效期时间过短，请重新设置");
        return false;
      }
      let data = {
        name: "NO." + util.timeCharge(time), // 券名称
        parkId: list.shop.parkId, // 车场ID
        type: _this.type, // 券类型
        unit: _this.unit, // 券单位
        value: _this.limit, // 单张券额度
        price: _this.money, // 单张券价格
        userId: list.shopUser.id, // 操作员id
        userName: list.shopUser.realname, // 操作员名称
        shopId: list.shopUser.shopId, // 商家ID
        couponExpireTime: list.shop.expireTime, // 多次进出券有效时间
        total: _this.amount, // 券总张数
        codeBeginTime: time.slice(0, 19), //券开始时间
        codeEndTime: util.timeFormat(_this.value2), // 券截止时间
        remark:_this.fixedName
      };
      _this.$axios.post("/shopFixCodeSave", data).then((res) => {
        _this.placeholder =
          "https://g.zaztservice.com/park-shop/scanQrFixCode?fixCodeId=" + res.data;
        _this.qrCode(_this.placeholder);
      });
    },
    // 卷数量的递减
    subtraction(i) {
      var arr = this.shopCouponList[i];
      var index = i;
      let array = this.shopCouponList;
      let type = arr.type;
      var timeEnd = parseInt(array[index].fix);
      timeEnd -= 1;
      if (timeEnd >= 0) {
        // 当使用了全免券进行更换时
        if (type == 4) {
          this.employ = 0;
          this.unit = "";
          this.type = 0;
          this.free = "扣费（元）";
          array[index].fix = timeEnd;
          this.getTotalPrice();
          return;
        } else {
          if (timeEnd > 0) {
            // 判断当前券不为0时进入计算
            array[index].fix = timeEnd;
            this.getTotalPrice(); // 计算合计值及金额
          } else if (timeEnd == 0) {
            // 判断当前券张数为0时
            var del = this.verdict;
            delete del[arr.name]; // 将键值对中内容进行删除
            var nums = Object.keys(this.verdict).length; // 判断键值对对象的长度
            if (nums == 0) {
              // 当键值对为 0 时代表券以全部清空，恢复原始数值得以进行后期选择
              this.employ = 0;
              this.unit = 0;
              this.units = this.units;
              this.type = 0;
              this.ticketTotal = "优惠合计";
            }
            array[index].fix = timeEnd;
            this.getTotalPrice();
          }
        }
      } else {
        util.hint(400, "使用的优惠券张数不能小于0");
      }
    },
    mousewheel(index, e) {
      if (e.deltaY < 0) {
        this.addition(index);
      } else {
        if (this.shopCouponList[index].fix - 1 >= 0) {
          this.subtraction(index);
        }
      }
      return false;
    },
    // 卷数量的递增
    addition(i) {
      // 拿到当前行数据
      var arr = this.shopCouponList[i];
      var index = i;
      let array = this.shopCouponList;
      let addNum = util.addcount(array);
      if (this.addconuts != 0 && addNum == this.addconuts) {
        util.hint(400, "最多只能使用" + this.addconuts + "张优惠券");
        return false;
      }
      let type = arr.type; // 拿到当前券的类型
      let units = this.units; // 判断是否为同种类型券
      var timeEnd = parseInt(array[index].fix); // 在页面中展示券的使用数量
      timeEnd += 1;
      let num = util.count(array, "add");
      // 使用全免券
      if (
        (type == 4 && this.employ == 0 && timeEnd == 1 && num == 0) ||
        ((type == 3 || type == 13) && this.employ == 0) ||
        (type == 10 && this.employ == 0)
      ) {
        if (type == 4) {
          let statu = JSON.parse(sessionStorage.getItem("shopData")).shop
            .isFree;
          if (statu == 2) {
            this.employ = 2;
            this.unit = 999;
            this.type = type;
            this.free = "限额（元）";
          } else {
            this.employ = 2;
            this.unit = 999;
            this.type = type;
          }
        } else if (type == 3 || type == 13) {
          this.employ = type;
          this.unit = 5;
          this.type = type;
          if(type == 13) {
            this.ticketTotal = "最大减免金额";
          }
        } else if (type == 10) {
          this.employ = 1;
          this.unit = 10;
          this.type = type;
        }
        array[index].fix = timeEnd;
        this.getTotalPrice();
      } else if (type != 4 && this.employ != 2 && type != 3 && type != 13 && type != 10) {
        // 当前券不属于全免券且没有使用过全免券时且不为折扣券时
        if (
          this.unit == 0 ||
          (array[index].unit == units && array[index].type == this.type)
        ) {
          var tianj = this.verdict;
          tianj[arr.name] = timeEnd;
          this.employ = 1;
          this.unit = array[index].unit;
          this.verdict = tianj;
          this.units = array[index].unit;
          this.type = type;
          if (array[index].type == 12) {
            this.employ = 1;
            this.unit = array[index].unit;
            this.type = type;
            this.ticketTotal = "最大减免金额";
          }
        } else {
          util.hint(400, "不同类型券不可叠加");
          return;
        }
        array[index].fix = timeEnd;
        this.getTotalPrice();
      } else if (type == 4 && timeEnd > 1) {
        // 第二次点击全免券时
        util.hint(400, "全免券不能叠加使用");
      } else if ((type == 3 || type == 13) && this.employ != 2) {
        util.hint(400, "折扣券不能叠加使用");
      } else if (type == 10) {
        util.hint(400, "特定收费券不能叠加使用");
      } else {
        util.hint(400, "全免券不能与其他优惠类型券叠加使用");
      }
    },

    getTotalPrice() {
      // 计算使用券的总价
      let array = this.shopCouponList; // 获取购物车列表
      let total = 0;
      let amount = 0;
      for (let i = 0; i < array.length; i++) {
        // 循环列表得到每个数据
        if(this.employ == 13 && array[i].fix != 0) {
          amount = array[i].value; // 所有合计数量
          total = array[i].fix * array[i].remark; // 所有价格加起来
        } else {
          amount += array[i].fix * array[i].value; // 所有合计数量
          total += array[i].fix * array[i].price; // 所有价格加起来
        }
      } // 最后赋值到data中渲染到页面
      this.shopCouponList = array;
      this.totalMoney = total.toFixed(2);
      this.money = total.toFixed(2);
      this.limit = amount;
      this.unit = this.unit;
      var ticketName = "";
      switch (this.unit) {
        case 1:
          ticketName = "小时";
          break;
        case 2:
          ticketName = "分钟";
          break;
        case 3:
          ticketName = "天";
          break;
        case 4:
          ticketName = "元";
          break;
        case 5:
          ticketName = "折";
          break;
        case 999:
          ticketName = "全免券";
          break;
        default:
          break;
      }
      if (this.unit == 999) {
        this.limit = "";
      }
      this.ticketName = ticketName;
    },
  },
};
</script>


<style lang="less" scoped>
@import url(../assets/css/qrcode.css);
@import url(../assets/css/fixed/fixed.css);
</style>


// WEBPACK FOOTER //
// src/components/fixedCode.vue